export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      isInitModal: false
    }
  },
  computed: {
    innerIsOpen: {
      get () {
        return this.isOpen
      },
      set (isOpen) {
        if (isOpen) this.open()
        else this.close()
      }
    }
  },
  watch: {
    isOpen: {
      handler (isOpen) {
        if (!isOpen) {
          this.clear?.()
          return
        }
        if (!this.isInitModal) this.firstInit?.()
        this.init?.()
        this.isInitModal = true
      },
      immediate: true
    }
  },
  methods: {
    close () {
      this.$emit('update:is-open', false)
      this.$emit('close')
    },
    open () {
      this.$emit('update:is-open', true)
      this.$emit('open')
    }
  }
}
